import trim from 'lodash/trim'

/** Optional override when short links are served from a different origin than REACT_APP_BASE_URL */
export function resolveShortLinkBaseUrl() {
  const fromEnv = trim(process.env.REACT_APP_SHORT_LINK_PUBLIC_BASE)
  if (fromEnv) {
    return fromEnv.replace(/\/$/, '')
  }
  const base = trim(process.env.REACT_APP_BASE_URL)
  if (base) {
    return base.replace(/\/$/, '')
  }
  return ''
}

/** Full public short URL; prefers value returned by the API (uses server env / Host). */
export function buildShortLinkUrl(slug, serverShortUrl) {
  if (serverShortUrl) return serverShortUrl
  const base = resolveShortLinkBaseUrl()
  if (!base || !slug) return ''
  return `${base}/s/${slug}`
}
